import { render, staticRenderFns } from "./IconChat.vue?vue&type=template&id=7802b2d6&scoped=true"
import script from "./IconChat.vue?vue&type=script&lang=js"
export * from "./IconChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7802b2d6",
  null
  
)

export default component.exports